var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.5005C29 6.49235 22.5081 0.000488281 14.5 0.000488281C6.49187 0.000488281 0 6.49235 0 14.5005C0 21.7379 5.30243 27.7366 12.2344 28.8243V18.6919H8.55274V14.5005H12.2344V11.306C12.2344 7.67189 14.3991 5.66456 17.7112 5.66456C19.2977 5.66456 20.957 5.94775 20.957 5.94775V9.51611H19.1286C17.3274 9.51611 16.7656 10.6338 16.7656 11.7805V14.5005H20.7871L20.1442 18.6919H16.7656V28.8243C23.6976 27.7366 29 21.7379 29 14.5005Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1442 18.6919L20.7871 14.5005H16.7656V11.7805C16.7656 10.6338 17.3274 9.51611 19.1286 9.51611H20.957V5.94775C20.957 5.94775 19.2977 5.66455 17.7112 5.66455C14.3991 5.66455 12.2344 7.67188 12.2344 11.306V14.5005H8.55273V18.6919H12.2344V28.8243C12.9839 28.9418 13.7414 29.0007 14.5 29.0005C15.2708 29.0005 16.0274 28.9401 16.7656 28.8243V18.6919H20.1442Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.903cf808a74e01993cc8b4f58e562f1f.svg";
export { ForwardRef as ReactComponent };